import { SchemaSave } from './SchemaSave';
import { CustomSchema } from './../diagram/CustomSchema';
import { BlockType } from '../compiler/factory';
import DiagramIDE from "../ide/DiagramIDE";
import { CustomRender, IfRender, WhileRender } from '../diagram/renders';

export class SchemaSerializor {

    public static serialize(): string {
        let save: SchemaSave = {
            ids: [],
            schemas: [],
            nodeIDStart: DiagramIDE.getID()
        };

        DiagramIDE.getIDE().validatedSchemas.forEach((value, key) => {
            save.ids.push(key);
            save.schemas.push(value);
        })

        return JSON.stringify(save);
    }

    public static deserialize(json: string): [Map<string, CustomSchema>, string] {
        let save = JSON.parse(json) as SchemaSave;

        let valSchemas = new Map();

        for (let i = 0; i < save.ids.length; i++) {
            let schema = save.schemas[i];

            schema.nodes.forEach(node => {
                switch (node.blockType) {
                    case BlockType.IF:
                        node.render = IfRender;
                        break;
                    case BlockType.WHILE:
                        node.render = WhileRender;
                        break;
                    default:
                        node.render = CustomRender;
                }
            });

            valSchemas.set(save.ids[i], schema);
        }

        return [valSchemas, save.nodeIDStart];
    }
}